module.exports = __webpack_public_path__ + "static/media/ashleyMadisonLogo.bc732b22.jpg";